import * as React from 'react';
import * as styles from './MortgageCalculator.css';

interface IMortgageCalculatorProps {
  propertyCost: React.ReactNode;
  downPayment: React.ReactNode;
  downPaymentLabels: React.ReactNode;
  creditTerm: React.ReactNode;
  creditTermLabels: React.ReactNode;
  summary: React.ReactNode;
  callback: React.ReactNode;
}

export function MortgageCalculator({
  propertyCost,
  downPayment,
  downPaymentLabels,
  creditTerm,
  creditTermLabels,
  summary,
  callback,
}: IMortgageCalculatorProps) {
  return (
    <article className={styles['container']}>
      <div className={styles['side']}>
        {propertyCost}

        <div className={styles['slider-item']}>
          {downPayment}
          {downPaymentLabels}
        </div>

        <div className={styles['slider-item']}>
          {creditTerm}
          {creditTermLabels}
        </div>
      </div>

      <div className={styles['side']}>
        {summary}
        <div className={styles['callback']}>{callback}</div>
      </div>
    </article>
  );
}
